export default __webpack_public_path__ + "static/media/invalid-name.72a9b05d.svg";